var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgButtonarrowBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "13px",
    viewBox: "0 0 8 13",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "buttonarrow_white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-266.000000, -295.000000)",
    strokeWidth: 2,
    stroke: "#343434"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(0.000000, 128.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(-6.000000, -44.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(161.000000, 102.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(1.000000, 95.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "buttonarrow_white",
    transform: "translate(110.949747, 20.449747) rotate(45.000000) translate(-110.949747, -20.449747) ",
    points: "107.449747 16.9497475 107.449747 16.9497475 114.449747 16.9497475 114.449747 23.9497475"
  }))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButtonarrowBlack);
export default __webpack_public_path__ + "static/media/buttonarrow_black.0ab9afabe88ad776c0f983f9ecf084dc.svg";
export { ForwardRef as ReactComponent };